<template>
  <div>
    <b-modal
      id="modal-input"
      centered
      size="lg"
      title="Input Pengajuan Cuti Karyawan"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Karyawan" label-cols-md="3">
          <Multiselect
            v-model="data.dataKaryawanId"
            :options="listKaryawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Karyawan --"
            label="namaKaryawan"
            track-by="NIK"
            @input="cekSisa(data.dataKaryawanId)"
          ></Multiselect>
        </b-form-group>

        <b-form-group label="Sisa Cuti" label-cols-md="3">
          <b-form-input
            disabled
            v-model="data.sisaCuti"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Tanggal Cuti" label-cols-md="3">
          <date-picker
            v-model="data.tanggalCuti"
            style="width: 100%"
          ></date-picker>
        </b-form-group>

        <b-form-group label="Lama Cuti (Hari)" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('jumlahHari')"
            type="number"
            v-model="data.jumlahHari"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')">
          Batal
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxValue } from "vuelidate/lib/validators";
export default {
  name: "modalInput",
  props: ["listKaryawan"],
  data() {
    return {
      data: {
        dataKaryawanId: "",
        tanggalPengajuanCuti: "",
        jumlahHari: "",
        tanggalCuti: "",
        sisaCuti: "",
        maxCuti: 2,
      },
      button: "Simpan",
      busy: false,
      // listKaryawan: [],
      shift: [],
      status: [
        { value: 0, text: "Berangkat" },
        { value: 1, text: "Cuti" },
        { value: 2, text: "Dinas" },
        { value: 3, text: "Cuti Hamil" },
        { value: 4, text: "Ijin" },
        { value: 5, text: "Sakit" },
        { value: 6, text: "Alpha" },
        { value: 7, text: "Ijin Keluarga Meninggal" },
        { value: 8, text: "Cuti Istri Melahirkan" },
        { value: 9, text: "Cuti Menikah" },
        { value: 10, text: "Ijin Jatah Libur" },
      ],
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dataKaryawanId: {
        required,
      },
      tanggalCuti: {
        required,
      },
      jumlahHari: {
        required,
        maxValue: maxValue(2),
      },
    },
  },
  mounted() {
    // this.getKaryawan();
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async cekSisa(x) {
      let vm = this;
      let cuti = await vm.$axios.get("pengajuanCuti/cekSisaCuti/" + x.id);
      vm.data.sisaCuti = cuti.data.data[0].totalCuti;
    },
    // async getKaryawan() {
    //   let vm = this;
    //   let listKaryawan = await vm.$axios.get(
    //     "suratPerjanjianKerja/listPerjanjianDibuat"
    //   );

    //   console.log(listKaryawan.data.data, "ini list karyawanaa");
    //   let penampung = listKaryawan.data.data;
    //   vm.listKaryawan = penampung.map((item) => {
    //     item.dataKaryawan =
    //       item.namaKaryawan + " - " + item.namaDivisi + " - " + item.namaPosisi;
    //     return item;
    //   });

    //   let shift = await vm.$axios.get("masterShift/list");
    //   // console.log(shift.data.data);
    //   vm.shift = shift.data.data.map((item) => {
    //     return { value: item.id, text: item.kategoriShift };
    //   });
    // },

    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.dataKaryawanId = vm.data.dataKaryawanId.id;
      vm.data.tanggalPengajuanCuti = vm.$moment();
      vm.$axios
        .post("pengajuanCuti/register", vm.data)
        .then((res) => {
          // console.log(res.data.message);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.data = {
              dataKaryawanId: "",
              tanggalPengajuanCuti: "",
              jumlahHari: "",
              tanggalCuti: "",
              sisaCuti: "",
              maxCuti: 2,
            };
            vm.$bvModal.hide("modal-input");
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL INPUT DATA CUTI KARYAWAN",
              showing: true,
            });
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$bvModal.hide("modal-input");
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            vm.$bvModal.hide("modal-input");
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$bvModal.hide("modal-input");
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          // vm.$bvModal.hide("modal-input");
        });
    },
  },
};
</script>
